export default __webpack_public_path__ + "static/media/payzone.24972797.png";